import { SET_ACTIVATEDRIVER } from '../actions';

const driverstatus = (state = [], action) => {
  switch (action.type) {
	case SET_ACTIVATEDRIVER:
      return [...action.value];  
    default: return state;
  }
}

export default driverstatus;
